(function() {
  'use strict';

  // Format money in GBP
  function formatMoney(amountInPence) {
    return '£' + (amountInPence / 100).toFixed(2);
  }

  // ============================================
  // Get protection price from HTML
  // ============================================
  function getProtectionPrice() {
    const priceElement = document.querySelector('.gents-protection-price');
    if (!priceElement) return 299;
    
    const priceText = priceElement.textContent.trim();
    const priceValue = parseFloat(priceText.replace('£', '').replace(',', ''));
    return Math.round(priceValue * 100);
  }

  // ============================================
  // Get protection product variant ID
  // ============================================
  async function getProtectionVariantId() {
    try {
      const response = await fetch('/products/gents-shipping-protection.js');
      const product = await response.json();
      
      if (product && product.variants && product.variants.length > 0) {
        return product.variants[0].id;
      }
      
      return null;
    } catch (error) {
      console.error('Error fetching protection product:', error);
      return null;
    }
  }

  // ============================================
  // Check if protection is in cart
  // ============================================
  async function isProtectionInCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Check if any item has the protection product handle
      for (let item of cart.items) {
        if (item.handle === 'gents-shipping-protection') {
          return { inCart: true, key: item.key, quantity: item.quantity };
        }
      }
      
      return { inCart: false };
    } catch (error) {
      console.error('Error checking cart:', error);
      return { inCart: false };
    }
  }

  // Escape Shopify-provided strings before inserting them into the manually rendered cart HTML.
  function escapeCartHTML(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function(character) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[character];
    });
  }

  // ============================================
  // Build cart items HTML manually from cart data
  // ============================================
  function buildCartItemsHTML(cart) {
    if (!cart || cart.item_count === 0) {
      return '';
    }
    
    let html = '';
    
    cart.items.forEach(function(item, index) {
      // Skip protection product in the items list (it's shown as checkbox)
      if (item.handle === 'gents-shipping-protection') {
        return;
      }
      
      const itemPrice = formatMoney(item.final_price);
      const itemOriginalPrice = formatMoney(item.original_price);
      const hasDiscount = item.original_price > item.final_price;
      
      html += '<div class="cart__item' + (index === cart.items.length - 1 ? ' cart__item--no-border' : '') + '" data-item="' + item.key + '">';
      
      // Image
      html += '<div class="cart__item__image">';
      html += '<a href="' + item.url + '">';
      if (item.image) {
        html += '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">';
      }
      html += '</a>';
      html += '</div>';
      
      // Content
      html += '<div class="cart__item__content">';
      html += '<div class="cart__item__content-inner">';
      
      // Title
      html += '<h4 class="cart__item__title"><a href="' + escapeCartHTML(item.url) + '">' + escapeCartHTML(item.product_title || item.title) + '</a></h4>';

      // Shopify's /cart.js AJAX response does not expose line_item.item_components.
      // Render the known fixed GENTS curated KIT contents from this local mapping instead.
      // These are display-only nested rows; the Shopify Bundle remains the single priced cart line.
      const kitTitle = String(item.product_title || item.title || '').toLowerCase();
      const kitContents = [
        {
          match: ['everyday kit', 'gents everyday kit'],
          products: ['ACCOLADE', 'TEMPEST', 'MERIDIAN']
        },
        {
          match: ['date night kit', 'gents date night kit'],
          products: ['SOLSTICE', 'DYNASTY', 'MAGNATE']
        },
        {
          match: ['after dark kit', 'gents after dark kit'],
          products: ['SANCTUM', 'IMPERIUM', 'CITADEL']
        }
      ];
      const matchedKit = kitContents.find(function(kit) {
        return kit.match.some(function(name) { return kitTitle.includes(name); });
      });
      if (matchedKit) {
        html += '<div class="gents-bundle-components" aria-label="Items included in ' + escapeCartHTML(item.product_title || item.title) + '">';
        matchedKit.products.forEach(function(productName) {
          html += '<div class="gents-bundle-component">';
          html += '<div class="gents-bundle-component__details">';
          html += '<span class="gents-bundle-component__name">' + escapeCartHTML(productName) + '</span>';
          html += '<span class="gents-bundle-component__quantity">1 ×</span>';
          html += '</div></div>';
        });
        html += '</div>';
      }
      
      // Variant options
      html += '<div class="cart__item__meta">';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        html += '<p class="cart__item__selected-options"><strong>Variant:</strong> <span>' + item.variant_title + '</span></p>';
      }
      html += '</div>';
      
      // Remove button
      html += '<a class="cart__item__remove" href="/cart/change?line=' + (index + 1) + '&quantity=0" data-item-remove data-id="' + item.key + '">';
      html += '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-cancel" viewBox="0 0 20 20">';
      html += '<path d="M15.89 14.696l-4.734-4.734 4.717-4.717c.4-.4.37-1.085-.03-1.485s-1.085-.43-1.485-.03L9.641 8.447 4.97 3.776c-.4-.4-1.085-.37-1.485.03s-.43 1.085-.03 1.485l4.671 4.671-4.688 4.688c-.4.4-.37 1.085.03 1.485s1.085.43 1.485.03l4.688-4.687 4.734 4.734c.4.4 1.085.37 1.485-.03s.43-1.085.03-1.485z"/>';
      html += '</svg>';
      html += ' Remove';
      html += '</a>';
      
      html += '</div>'; // content-inner
      
      // UPDATED: Quantity and Price in a row wrapper
      html += '<div class="cart__item__bottom-row">';
      
      // Quantity selector
      html += '<div class="cart__quantity" data-quantity-holder>';
      html += '<button class="cart__quantity-minus" type="button" name="minus" data-quantity-minus data-quantity-button></button>';
      html += '<input class="cart__quantity-field" type="number" name="updates[]" data-quantity-field data-id="' + item.key + '" value="' + item.quantity + '" min="0">';
      html += '<button class="cart__quantity-plus" type="button" name="plus" data-quantity-plus data-quantity-button></button>';
      html += '</div>';
      
      // Price
      html += '<p class="cart__price">';
      if (hasDiscount) {
        html += '<ins>' + itemPrice + '</ins>';
        html += '<del>' + itemOriginalPrice + '</del>';
      } else {
        html += itemPrice;
      }
      html += '</p>';
      
      html += '</div>'; // cart__item__bottom-row
      
      html += '</div>'; // content
      html += '</div>'; // cart__item

    });
    
    return html;
  }

  // ============================================
  // Update cart drawer - PRESERVE template content
  // ============================================
  async function refreshCartDrawerHTML() {
    console.log('🔄 Building cart HTML manually from cart data...');
    
    try {
      const cart = await fetchCartData();
      if (!cart) return false;
      
      console.log('📊 Cart has', cart.item_count, 'items');
      
      const itemsHolder = document.querySelector('[data-items-holder]');
      const emptySection = document.querySelector('[data-cart-empty]');
      const footHolder = document.querySelector('[data-foot-holder]');
      
      if (!itemsHolder || !emptySection) {
        console.error('❌ Could not find cart elements');
        return false;
      }
      
      // Check actual product count (excluding protection)
      let actualProductCount = 0;
      for (let item of cart.items) {
        if (item.handle !== 'gents-shipping-protection') {
          actualProductCount++;
        }
      }
      
      if (actualProductCount > 0) {
        console.log('✅ Cart has items - building HTML');
        
        const subscriptionBtn = itemsHolder.querySelector('.gents-subscription-upgrade');
        const subscriptionModal = itemsHolder.querySelector('.gents-subscription-modal');
        const subscriptionStyles = itemsHolder.querySelector('style');
        const subscriptionScript = itemsHolder.querySelector('script');
        
        const itemsHTML = buildCartItemsHTML(cart);
        const itemsWrapper = document.createElement('div');
        itemsWrapper.innerHTML = itemsHTML;
        
        itemsHolder.innerHTML = '';
        itemsHolder.appendChild(itemsWrapper);
        
        if (subscriptionBtn) {
          itemsHolder.appendChild(subscriptionBtn.cloneNode(true));
        }
        
        if (subscriptionModal) {
          itemsHolder.appendChild(subscriptionModal.cloneNode(true));
        }
        
        if (subscriptionStyles) {
          itemsHolder.appendChild(subscriptionStyles.cloneNode(true));
        }
        
        if (subscriptionScript) {
          const newScript = document.createElement('script');
          newScript.textContent = subscriptionScript.textContent;
          itemsHolder.appendChild(newScript);
        }
        
        itemsHolder.classList.remove('is-hidden');
        emptySection.classList.add('is-hidden');
        if (footHolder) footHolder.classList.remove('is-hidden');
        
        console.log('✅ Items displayed with template content preserved');
        
      } else {
        console.log('✅ Cart is empty - showing empty message');
        
        itemsHolder.classList.add('is-hidden');
        emptySection.classList.remove('is-hidden');
        if (footHolder) footHolder.classList.add('is-hidden');
      }
      
      setupDiscountInput();
      setupCheckoutProtection();
      setupQuantityButtons();
      loadProductRecommendations();
      
      console.log('✅ Cart drawer updated');
      return true;
      
    } catch (error) {
      console.error('❌ Error updating cart drawer:', error);
      return false;
    }
  }

  // ============================================
  // Setup quantity buttons
  // ============================================
  function setupQuantityButtons() {
    document.querySelectorAll('[data-quantity-plus]').forEach(function(btn) {
      btn.addEventListener('click', async function() {
        const input = this.parentElement.querySelector('[data-quantity-field]');
        const itemId = input.getAttribute('data-id');
        const newQty = parseInt(input.value) + 1;
        await updateCartItemQuantity(itemId, newQty);
      });
    });
    
    document.querySelectorAll('[data-quantity-minus]').forEach(function(btn) {
      btn.addEventListener('click', async function() {
        const input = this.parentElement.querySelector('[data-quantity-field]');
        const itemId = input.getAttribute('data-id');
        const newQty = Math.max(0, parseInt(input.value) - 1);
        await updateCartItemQuantity(itemId, newQty);
      });
    });
    
    document.querySelectorAll('[data-quantity-field]').forEach(function(input) {
      input.addEventListener('change', async function() {
        const itemId = this.getAttribute('data-id');
        const newQty = Math.max(0, parseInt(this.value) || 0);
        await updateCartItemQuantity(itemId, newQty);
      });
    });
    
    document.querySelectorAll('[data-item-remove]').forEach(function(btn) {
      btn.addEventListener('click', async function(e) {
        e.preventDefault();
        const itemId = this.getAttribute('data-id');
        await updateCartItemQuantity(itemId, 0);
      });
    });
  }

  // ============================================
  // Update cart item quantity
  // ============================================
  async function updateCartItemQuantity(itemId, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: itemId,
          quantity: quantity
        })
      });
      
      if (response.ok) {
        console.log('✅ Quantity updated');
      }
    } catch (error) {
      console.error('❌ Error updating quantity:', error);
    }
  }

  // ============================================
  // Open cart drawer
  // ============================================
  function openCartDrawer() {
    console.log('🎯 Opening cart drawer');
    const cartToggle = document.querySelector('[data-cart-toggle]');
    if (cartToggle) {
      cartToggle.click();
      console.log('✅ Cart drawer opened');
    }
  }

  // Update free shipping progress bar
  function updateFreeShipping(cartTotal) {
    const freeShippingThreshold = 4000;
    const remaining = freeShippingThreshold - cartTotal;
    const percentage = Math.min((cartTotal / freeShippingThreshold) * 100, 100);
    
    const progressBar = document.querySelector('.gents-free-shipping__bar');
    const container = document.querySelector('[data-gents-free-shipping]');
    const messageWrapper = document.querySelector('.gents-free-shipping__message');
    
    if (progressBar) {
      progressBar.value = percentage;
    }
    
    if (container && messageWrapper) {
      if (remaining > 0) {
        container.classList.remove('is-success');
        messageWrapper.innerHTML = `
          <span class="gents-free-shipping__icon">🚚</span>
          <span class="gents-free-shipping__text">You're <strong class="remaining-amount">${formatMoney(remaining)}</strong> away from free shipping!</span>
        `;
      } else {
        container.classList.add('is-success');
        messageWrapper.innerHTML = `
          <span class="gents-free-shipping__success">✨ Congratulations! You've unlocked <strong>FREE SHIPPING!</strong></span>
        `;
      }
    }
    
    updateShippingInfo(remaining);
  }

  // Update shipping info in cart summary
  function updateShippingInfo(remaining) {
    const shippingInfo = document.querySelector('.gents-shipping-info');
    if (!shippingInfo) return;
    
    let shippingText = shippingInfo.querySelector('.gents-shipping-threshold, .gents-shipping-free');
    if (!shippingText) {
      shippingText = document.createElement('span');
      shippingInfo.appendChild(shippingText);
    }
    
    if (remaining > 0) {
      shippingText.className = 'gents-shipping-threshold';
      shippingText.textContent = 'Spend ' + formatMoney(remaining) + ' for free shipping';
    } else {
      shippingText.className = 'gents-shipping-free';
      shippingText.textContent = 'FREE';
    }
  }

  // ============================================
  // Update cart totals - no manual protection addition
  // ============================================
  function updateTotals(cartTotal, itemCount) {
    const totalElement = document.querySelector('.gents-total-amount');
    if (totalElement) {
      totalElement.textContent = formatMoney(cartTotal);
    }
    
    const countBadge = document.querySelector('.cart-count-badge');
    if (countBadge && itemCount !== undefined) {
      countBadge.textContent = itemCount;
    }
    
    document.querySelectorAll('[data-cart-count]').forEach(function(el) {
      el.textContent = itemCount;
    });
    
    // Checkout button shows Shopify cart total (includes protection product)
    const checkoutBtn = document.querySelector('.gents-checkout-btn');
    if (checkoutBtn) {
      const lockIcon = checkoutBtn.querySelector('.animated-icon');
      const iconHTML = lockIcon ? lockIcon.outerHTML : '';
      
      checkoutBtn.innerHTML = iconHTML + 'Checkout | ' + formatMoney(cartTotal);
    }
  }

  // Fetch cart data from Shopify
  async function fetchCartData() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      return cart;
    } catch (error) {
      console.error('Error fetching cart:', error);
      return null;
    }
  }

  // Load product recommendations  
  async function loadProductRecommendations() {
    const container = document.getElementById('gents-recommendations-container');
    if (!container) return;
    
    const section = document.querySelector('.gents-recommendations-section');
    const productId = section ? section.getAttribute('data-product-id') : null;
    
    if (!productId) return;
    
    try {
      const response = await fetch('/recommendations/products.json?product_id=' + productId + '&limit=1');
      const data = await response.json();
      
      if (!data.products || data.products.length === 0) {
        container.innerHTML = '<p class="gents-recommendations-loading">No recommendations available</p>';
        return;
      }
      
      let html = '';
      data.products.forEach(function(product) {
        const variant = product.variants[0];
        const price = variant.price;
        const comparePrice = variant.compare_at_price;
        const hasDiscount = comparePrice && comparePrice > price;
        const savings = hasDiscount ? Math.round(((comparePrice - price) / comparePrice) * 100) : 0;
        
        html += '<div class="gents-recommendation-item">';
        html += '<div class="gents-recommendation-image">';
        if (product.featured_image) {
          html += '<img src="' + product.featured_image + '" alt="' + product.title + '">';
        }
        html += '</div>';
        
        html += '<div class="gents-recommendation-details">';
        html += '<h4 class="gents-recommendation-title">' + product.title + '</h4>';
        html += '<div class="gents-recommendation-price">';
        html += '<span class="gents-recommendation-price-current">' + formatMoney(price) + '</span>';
        if (hasDiscount) {
          html += '<span class="gents-recommendation-price-original">' + formatMoney(comparePrice) + '</span>';
          html += '<span class="gents-recommendation-savings">' + savings + '% Savings</span>';
        }
        html += '</div>';
        
        if (product.variants.length > 1) {
          html += '<div class="gents-recommendation-variant">';
          html += '<select data-variant-select data-product-id="' + product.id + '">';
          product.variants.forEach(function(v) {
            html += '<option value="' + v.id + '">' + v.title + '</option>';
          });
          html += '</select>';
          html += '</div>';
        }
        html += '</div>';
        
        html += '<button class="gents-recommendation-add" ';
        html += 'data-variant-id="' + variant.id + '" ';
        html += 'data-product-id="' + product.id + '" ';
        html += 'onclick="addRecommendationToCart(this)">';
        html += 'Add';
        html += '</button>';
        html += '</div>';
      });
      
      container.innerHTML = html;
      
    } catch (error) {
      console.error('Error loading recommendations:', error);
      container.innerHTML = '<p class="gents-recommendations-loading">Could not load recommendations</p>';
    }
  }

  // Add recommendation to cart
  window.addRecommendationToCart = async function(button) {
    const variantSelect = button.parentElement.querySelector('[data-variant-select]');
    const variantId = variantSelect ? variantSelect.value : button.getAttribute('data-variant-id');
    
    if (!variantId) {
      alert('Please select a variant');
      return;
    }
    
    button.disabled = true;
    button.textContent = 'Adding...';
    
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }]
        })
      });
      
      if (response.ok) {
        button.textContent = 'Added!';
        setTimeout(function() {
          refreshCart(false);
          button.disabled = false;
          button.textContent = 'Add';
        }, 1000);
      } else {
        throw new Error('Failed to add');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      button.disabled = false;
      button.textContent = 'Add';
      alert('Could not add product to cart');
    }
  };

  // ============================================
  // Refresh all cart displays
  // ============================================
  async function refreshCart(shouldOpenDrawer) {
    console.log('🔄 Refreshing cart...');
    
    const cart = await fetchCartData();
    
    if (cart) {
      console.log('📊 Cart has', cart.item_count, 'items, total:', formatMoney(cart.total_price));
      
      await refreshCartDrawerHTML();
      await new Promise(resolve => setTimeout(resolve, 200));
      
      updateFreeShipping(cart.total_price);
      updateTotals(cart.total_price, cart.item_count);
      
      // Update checkbox state based on cart content
      await syncProtectionCheckbox();
      
      if (shouldOpenDrawer) {
        await new Promise(resolve => setTimeout(resolve, 200));
        openCartDrawer();
      }
      
      console.log('✅ Cart refresh complete');
    }
  }

  // ============================================
  // Sync protection checkbox with cart state
  // ============================================
  async function syncProtectionCheckbox() {
    const checkbox = document.getElementById('checkout-protection');
    if (!checkbox) return;
    
    const protection = await isProtectionInCart();
    
    // Update checkbox without triggering change event
    if (protection.inCart && !checkbox.checked) {
      checkbox.checked = true;
    } else if (!protection.inCart && checkbox.checked) {
      checkbox.checked = false;
    }
  }

  // ============================================
  // DISCOUNT CODE FUNCTIONALITY
  // ============================================

  /**
   * Apply discount code via Shopify Cart API
   * Shows discounted prices immediately in cart drawer
   */
  window.applyGentsDiscount = async function() {
    const input = document.getElementById('gents-discount-code');
    const discountCode = input ? input.value.trim() : '';
    
    if (!discountCode) {
      showDiscountMessage('Please enter a discount code', 'error');
      return;
    }
    
    const button = document.querySelector('.gents-discount-btn');
    const originalText = button ? button.textContent : 'Apply';
    
    if (button) {
      button.textContent = 'Applying...';
      button.disabled = true;
    }
    
    try {
      // Step 1: Apply discount code to cart
      const updateResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            'discount_code': discountCode
          }
        })
      });
      
      if (!updateResponse.ok) {
        throw new Error('Failed to apply discount');
      }
      
      // Step 2: Fetch cart with discount applied
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Step 3: Validate discount by checking with Shopify's discount API
      // We'll try to create a checkout with the discount to validate it
      const validateResponse = await fetch('/cart', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: 'discount=' + encodeURIComponent(discountCode)
      });
      
      // If we got here, discount is valid - show success
      showDiscountSuccess(discountCode, cart);
      updateCartWithDiscount(cart, discountCode);
      
      // Store discount for checkout
      sessionStorage.setItem('pending_discount', discountCode);
      
      if (button) {
        button.textContent = 'Applied!';
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);
      }
      
      if (input) {
        input.value = '';
      }
      
    } catch (error) {
      console.error('Error applying discount:', error);
      showDiscountMessage('Invalid discount code. Please try again.', 'error');
      
      if (button) {
        button.textContent = originalText;
        button.disabled = false;
      }
    }
  };

  /**
   * Show discount success message with code
   */
  function showDiscountSuccess(code, cart) {
    // Remove existing messages
    const existingMessages = document.querySelectorAll('.gents-discount-message');
    existingMessages.forEach(msg => msg.remove());
    
    // Create success message
    const message = document.createElement('div');
    message.className = 'gents-discount-message gents-discount-message--success';
    message.innerHTML = '✓ Discount code "' + code + '" applied! You\'ll see the discount at checkout.';
    
    // Insert after discount form
    const discountForm = document.querySelector('.gents-discount-form');
    if (discountForm && discountForm.parentNode) {
      discountForm.parentNode.insertBefore(message, discountForm.nextSibling);
    }
    
    // Auto-dismiss after 5 seconds
    setTimeout(() => {
      message.style.opacity = '0';
      setTimeout(() => message.remove(), 300);
    }, 5000);
    
    // Show discount tag
    showDiscountTag(code);
  }

  /**
   * Show discount message (success or error)
   */
  function showDiscountMessage(text, type) {
    // Remove existing messages
    const existingMessages = document.querySelectorAll('.gents-discount-message');
    existingMessages.forEach(msg => msg.remove());
    
    // Create message
    const message = document.createElement('div');
    message.className = 'gents-discount-message gents-discount-message--' + type;
    message.textContent = text;
    
    // Insert after discount form
    const discountForm = document.querySelector('.gents-discount-form');
    if (discountForm && discountForm.parentNode) {
      discountForm.parentNode.insertBefore(message, discountForm.nextSibling);
    }
    
    // Auto-dismiss after 4 seconds
    setTimeout(() => {
      message.style.opacity = '0';
      setTimeout(() => message.remove(), 300);
    }, 4000);
  }

  /**
   * Show discount tag in active discounts section
   */
  function showDiscountTag(code) {
    // Remove existing discount tags
    const existingTags = document.querySelectorAll('.gents-discount-tag');
    existingTags.forEach(tag => tag.remove());
    
    // Create active discounts container if it doesn't exist
    let activeContainer = document.querySelector('.gents-active-discounts');
    if (!activeContainer) {
      activeContainer = document.createElement('div');
      activeContainer.className = 'gents-active-discounts';
      
      const discountSection = document.querySelector('.gents-discount-section');
      if (discountSection) {
        discountSection.appendChild(activeContainer);
      }
    }
    
    // Create discount tag
    const discountTag = document.createElement('div');
    discountTag.className = 'gents-discount-tag';
    discountTag.innerHTML = `
      <span class="gents-discount-tag__text">${code}</span>
      <button class="gents-discount-tag__remove" onclick="removeDiscount('${code}')" aria-label="Remove discount">×</button>
    `;
    
    activeContainer.appendChild(discountTag);
  }

  /**
   * Update cart UI with discount information
   */
  function updateCartWithDiscount(cart, discountCode) {
    // Update checkout button to include discount
    const checkoutBtn = document.querySelector('.gents-checkout-btn');
    if (checkoutBtn) {
      // Store discount in button data attribute
      checkoutBtn.dataset.discount = discountCode;
    }
    
    // Add note about discount
    const totalSection = document.querySelector('.gents-total-section');
    if (totalSection) {
      let discountNote = totalSection.querySelector('.gents-discount-note');
      
      if (!discountNote) {
        discountNote = document.createElement('div');
        discountNote.className = 'gents-discount-note';
        totalSection.insertBefore(discountNote, totalSection.firstChild);
      }
      
      discountNote.innerHTML = `
        <div style="display: flex; align-items: center; gap: 8px; padding: 12px; background: #f0f9f1; border-radius: 6px; margin-bottom: 12px;">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 0L10.5 5.5L16 6.5L12 10.5L13 16L8 13L3 16L4 10.5L0 6.5L5.5 5.5L8 0Z" fill="#2d7a3e"/>
          </svg>
          <span style="font-size: 13px; color: #2d7a3e; font-weight: 500;">
            Discount will be applied at checkout
          </span>
        </div>
      `;
    }
  }

  /**
   * Remove discount code
   * FIXED: Stay in cart drawer, don't redirect
   */
  window.removeDiscount = async function(code) {
    try {
      console.log('🗑️ Removing discount code:', code);
      
      // Remove discount from cart attributes
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            'discount_code': ''
          }
        })
      });
      
      // Remove from sessionStorage
      sessionStorage.removeItem('pending_discount');
      
      // Remove discount tag
      const discountTag = document.querySelector('.gents-discount-tag');
      if (discountTag) {
        discountTag.remove();
      }
      
      // Remove discount note
      const discountNote = document.querySelector('.gents-discount-note');
      if (discountNote) {
        discountNote.remove();
      }
      
      // Remove discount from checkout button
      const checkoutBtn = document.querySelector('.gents-checkout-btn');
      if (checkoutBtn) {
        delete checkoutBtn.dataset.discount;
      }
      
      // Show success message
      showDiscountMessage('Discount code removed', 'success');
      
      console.log('✅ Discount removed successfully');
      
    } catch (error) {
      console.error('❌ Error removing discount:', error);
      showDiscountMessage('Error removing discount', 'error');
    }
  };

  /**
   * Setup checkout button to include discount
   */
  function setupCheckoutWithDiscount() {
    const checkoutBtn = document.querySelector('.gents-checkout-btn');
    
    if (checkoutBtn) {
      // Remove existing listener
      const newBtn = checkoutBtn.cloneNode(true);
      checkoutBtn.parentNode.replaceChild(newBtn, checkoutBtn);
      
      // Add new listener
      newBtn.addEventListener('click', function(e) {
        const discountCode = this.dataset.discount || sessionStorage.getItem('pending_discount');
        
        if (discountCode) {
          e.preventDefault();
          
          // Build checkout URL with discount
          const checkoutUrl = '/checkout?discount=' + encodeURIComponent(discountCode);
          
          // Redirect to checkout
          window.location.href = checkoutUrl;
        }
      });
    }
  }

  /**
   * Check for stored discount on cart load
   */
  function checkStoredDiscount() {
    const storedDiscount = sessionStorage.getItem('pending_discount');
    
    if (storedDiscount) {
      showDiscountTag(storedDiscount);
      
      const checkoutBtn = document.querySelector('.gents-checkout-btn');
      if (checkoutBtn) {
        checkoutBtn.dataset.discount = storedDiscount;
      }
    }
  }

  /**
   * Setup discount input
   */
  function setupDiscountInput() {
    const input = document.getElementById('gents-discount-code');
    if (input) {
      const newInput = input.cloneNode(true);
      input.parentNode.replaceChild(newInput, input);
      
      newInput.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          window.applyGentsDiscount();
        }
      });
    }
  }

  // ============================================
  // CHECKOUT PROTECTION - FIXED VERSION
  // ============================================

  /**
   * Setup checkout protection checkbox
   * FIXED: Prevents drawer from closing
   */
  function setupCheckoutProtection() {
    const checkbox = document.getElementById('checkout-protection');
    
    if (!checkbox) {
      console.log('⚠️ Checkout protection checkbox not found');
      return;
    }
    
    // Remove any existing event listeners by cloning
    const newCheckbox = checkbox.cloneNode(true);
    checkbox.parentNode.replaceChild(newCheckbox, checkbox);
    
    newCheckbox.addEventListener('change', async function(e) {
      // CRITICAL: Stop ALL event propagation
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      const isChecked = this.checked;
      
      console.log('🛡️ Protection checkbox changed to:', isChecked);
      
      // Disable checkbox temporarily to prevent multiple clicks
      this.disabled = true;
      
      // Store the cart drawer element and its state
      const cartDrawer = document.querySelector('#cart-drawer, [data-cart-drawer], .cart-drawer');
      const wasOpen = cartDrawer && cartDrawer.classList.contains('is-visible');
      
      try {
        // Get the protection product variant ID
        const protectionVariantId = await getProtectionVariantId();
        
        if (!protectionVariantId) {
          console.error('❌ Protection variant ID not found');
          this.checked = !isChecked; // Revert checkbox
          this.disabled = false;
          return;
        }
        
        if (isChecked) {
          // ADD protection to cart
          console.log('➕ Adding protection to cart...');
          
          const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [{
                id: protectionVariantId,
                quantity: 1
              }]
            })
          });
          
          if (!addResponse.ok) {
            throw new Error('Failed to add protection');
          }
          
          const result = await addResponse.json();
          console.log('✅ Protection added:', result);
          
        } else {
          // REMOVE protection from cart
          console.log('➖ Removing protection from cart...');
          
          // Get current cart
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          
          // Find protection item in cart
          const protectionItem = cart.items.find(item => 
            item.variant_id === protectionVariantId
          );
          
          if (protectionItem) {
            // Get the line number (1-indexed)
            const lineNumber = cart.items.indexOf(protectionItem) + 1;
            
            console.log(`Found protection at line ${lineNumber}, removing...`);
            
            const removeResponse = await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                line: lineNumber,
                quantity: 0
              })
            });
            
            if (!removeResponse.ok) {
              throw new Error('Failed to remove protection');
            }
            
            const result = await removeResponse.json();
            console.log('✅ Protection removed:', result);
          } else {
            console.log('⚠️ Protection not found in cart');
          }
        }
        
        // Update cart display WITHOUT triggering any events
        await updateCartDisplaySilently();
        
        // FORCE drawer to stay open if it was open
        if (wasOpen && cartDrawer) {
          setTimeout(function() {
            cartDrawer.classList.add('is-visible');
            cartDrawer.setAttribute('aria-hidden', 'false');
            document.body.classList.add('cart-drawer-open', 'overflow-hidden');
            console.log('🔓 Forced drawer to stay open');
          }, 50);
        }
        
        // Re-enable checkbox AFTER cart update completes
        this.disabled = false;
        
        console.log('✅ Protection update complete, checkbox state:', this.checked);
        
      } catch (error) {
        console.error('❌ Error updating protection:', error);
        
        // Revert checkbox state on error
        this.checked = !isChecked;
        this.disabled = false;
        
        // FORCE drawer to stay open even on error
        if (wasOpen && cartDrawer) {
          setTimeout(function() {
            cartDrawer.classList.add('is-visible');
            cartDrawer.setAttribute('aria-hidden', 'false');
            document.body.classList.add('cart-drawer-open', 'overflow-hidden');
          }, 50);
        }
        
        // Show error to user
        alert('Sorry, there was an error updating shipping protection. Please try again.');
      }
    });
    
    console.log('✅ Checkout protection setup complete');
  }

  /**
   * Update cart display silently without triggering ANY events
   * This prevents the drawer from closing
   */
  async function updateCartDisplaySilently() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      console.log('🔄 Updating cart display silently, total:', cart.total_price);
      
      // Update free shipping bar
      if (typeof updateFreeShipping === 'function') {
        updateFreeShipping(cart.total_price);
      }
      
      // Update total amount
      const totalElement = document.querySelector('.gents-total-amount');
      if (totalElement) {
        totalElement.textContent = formatMoney(cart.total_price);
      }
      
      // Update checkout button
      const checkoutBtn = document.querySelector('.gents-checkout-btn');
      if (checkoutBtn) {
        const lockIcon = checkoutBtn.querySelector('.animated-icon');
        const iconHTML = lockIcon ? lockIcon.outerHTML : '';
        checkoutBtn.innerHTML = `${iconHTML}Checkout | ${formatMoney(cart.total_price)}`;
      }
      
      // Update cart count badges
      document.querySelectorAll('[data-cart-count]').forEach(function(el) {
        el.textContent = cart.item_count;
      });
      
      const countBadge = document.querySelector('.cart-count-badge');
      if (countBadge) {
        countBadge.textContent = cart.item_count;
      }
      
      console.log('✅ Cart display updated silently');
      
      // DO NOT dispatch any events - this is critical
      // NO document.dispatchEvent(new Event('cart:updated'));
      // NO theme.trigger('cart:updated');
      
    } catch (error) {
      console.error('Error updating cart display:', error);
    }
  }

  // ============================================
  // WATCH CART CHANGES
  // ============================================

  /**
   * Watch for cart changes
   * FIXED: Ignore protection product to prevent drawer refresh
   */
  function watchCartChanges() {
    console.log('🔧 Setting up cart change detection...');
    
    let isProcessingCartAdd = false;
    let isProtectionUpdate = false;
    
    const originalFetch = window.fetch;
    window.fetch = function() {
      const args = arguments;
      const url = args[0];
      const options = args[1];
      
      return originalFetch.apply(this, args).then(async function(response) {
        // Check if this is a protection product being added/removed
        if (options && options.body) {
          try {
            const body = typeof options.body === 'string' ? JSON.parse(options.body) : options.body;
            
            // Check if adding protection product
            if (body.items && Array.isArray(body.items)) {
              const protectionVariantId = await getProtectionVariantId();
              const isProtectionItem = body.items.some(item => item.id === protectionVariantId);
              
              if (isProtectionItem) {
                console.log('🛡️ Protection product detected - skipping cart refresh');
                isProtectionUpdate = true;
                
                // Reset flag after a delay
                setTimeout(function() {
                  isProtectionUpdate = false;
                }, 1000);
                
                return response;
              }
            }
            
            // Check if changing/removing protection product
            if (body.line !== undefined || body.id) {
              const cartData = await fetch('/cart.js').then(r => r.json());
              const protectionVariantId = await getProtectionVariantId();
              const hasProtection = cartData.items.some(item => item.variant_id === protectionVariantId);
              
              if (hasProtection && url.includes('/cart/change')) {
                console.log('🛡️ Protection change detected - skipping cart refresh');
                isProtectionUpdate = true;
                
                // Reset flag after a delay
                setTimeout(function() {
                  isProtectionUpdate = false;
                }, 1000);
                
                return response;
              }
            }
          } catch (e) {
            // If parsing fails, continue normally
          }
        }
        
        // Only refresh cart if it's NOT a protection update
        if (!isProtectionUpdate) {
          if (url && typeof url === 'string' && url.includes('/cart/add') && response.ok && !isProcessingCartAdd) {
            isProcessingCartAdd = true;
            console.log('🛒 Item added to cart');
            
            setTimeout(async function() {
              await refreshCart(true);
              isProcessingCartAdd = false;
            }, 400);
          }
          else if (url && typeof url === 'string' && url.includes('/cart/change')) {
            console.log('🔄 Cart changed');
            setTimeout(function() {
              refreshCart(false);
            }, 400);
          }
        }
        
        return response;
      });
    };
    
    console.log('✅ Fetch interceptor installed');
  }

  // ============================================
  // INITIALIZE
  // ============================================

  /**
   * Initialize all cart functionality
   */
  function init() {
    console.log('==========================================');
    console.log('GENTS CART - COMPLETE FIXED VERSION');
    console.log('Protection handle: gents-shipping-protection');
    console.log('==========================================');
    
    setupDiscountInput();
    setupCheckoutProtection();
    setupQuantityButtons();
    setupCheckoutWithDiscount();
    checkStoredDiscount();
    watchCartChanges();
    
    setTimeout(function() {
      refreshCart(false);
    }, 1000);
  }

  // Start initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Listen for cart updates from theme
  document.addEventListener('cart:updated', function() {
    setTimeout(function() {
      refreshCart(false);
    }, 200);
  });

})();
